const appManagement = {
  loginName: "登录账号",
  realName: "用户姓名",
  nickName: "用户昵称",
  gender: "性别",
  birthDate: "生日",
  width1: "80px",
  status: "账户状态",
  loginTime: "最近登录时间",
  createdOn: "创建时间",
  all: "全部",
  enable: "启用",
  disable: "禁用",
  restPassword: "重设密码",
  restPwd: {
    updatePwdSuccess: "密码修改成功",
    msg1: "重置后密码为12345678"
  },
  detailDilago: {
    appTitle: "APP用户详情",
    personTitle: "个人信息",
    carTitle: "用户车辆",
    notifyTitle: "通知消息",
    maxSpeed: "超速阈值",
    securityModeAlarm: "安全模式报警",
    deviceUnplugReminder: "设备拔出提醒",
    safetyReminder: "安全提醒",
    geoFenceReminder: "地理围栏提醒",
    deviceOfflineReminder: "设备脱机提醒",
    activityReminder: "活动提醒",
    systemMessage: "系统消息",
    overSpeedAlarm: "超速报警",
    open: "开启",
    off: "关闭"
  }
} 
export default appManagement